import { Cancel } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

type FilesListProps = {
  onDelete: (file: any) => void;
  files: any[];
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  fileName: {
    textDecoration: 'underline',
  },
  errorText: {
    color: 'red',
    marginTop: '16px',
    display: 'block',
  },
}));

const FilesList = ({ onDelete, files }: FilesListProps) => {
  const classes = useStyles();

  const totalErrors = (files ?? []).reduce((acc, file) => acc + (file.errors?.length ?? 0), 0);

  return (
    <div>
      {totalErrors > 0 && (
        <Typography className={classes.errorText}>
          There are {totalErrors} errors in the files. Please validate and correct the files to sync the device import.
        </Typography>
      )}
      {files.map((file) => (
        <div key={file.name} className={classes.container}>
          <span className={classes.fileName}>{file.name ?? 'Device import: OnAsset Masterfile'}</span>
          <IconButton sx={{ color: 'black' }} onClick={() => onDelete(file)} size='large'>
            <Cancel />
          </IconButton>
        </div>
      ))}
    </div>
  );
};

export default FilesList;
